<template>
  <Row>
    <Col>
      <div class="d-flex">
        <div class="icon-stepper rounded-circle primary">
          <p v-text="1" inline v-if="!domainConfiguration.status" class="ml-2"/>
          <Icon v-else :icon="domainConfiguration.icon" class="mt-n1 ml-1" style="width: 15px; font-size:15px" iconSize="dense" color="shade-white"/>
        </div>
        <div class="ml-2" v-if="!domainConfiguration.status">
          <p class="text-paragraph-2 gray--text text--scale500" v-text="domainConfiguration.title"/>
          <p class="text-caption gray--text text--scale500" v-text="domainConfiguration.subTitle"/>
        </div>
        <div class="ml-2" v-else>
          <p class="text-paragraph-2 success--text" v-text="domainConfiguration.title"/>
        </div>
      </div>
      <div style="border-left: 1px solid" class="ml-3 py-4 mt-2">
        <div v-if="!domainConfiguration.status">
          <p class="text-caption ml-4">
            Quer utilizar um domínio registrado em outra empresa?
            <Link href="https://ajuda.locaweb.com.br/wiki/como-usar-um-dominio-que-esta-em-outro-provedor-hospedagem-wordpress-locaweb/#onde-fica-a-zona-de-dns-no-meu-provedor-de-dominio" target="blank" :ga="gEvents.vejaComoConfigurarDominio" color="primary">Veja como configurá-lo</Link>
          </p>
          <p class="text-caption ml-4">
            Obs: Caso já tenha feito essa configuração, aguarde o tempo de propagação. Os servidores da internet podem demorar até 48h para detectar essa alteração e aparecer como configurado aqui. Depois desse prazo faça testes de acesso ao seu site.
          </p>
        </div>
      </div>
      <div class="mt-2 d-flex">
        <div class="icon-stepper rounded-circle primary" v-if="sslConfiguration.security_wait">
          <p v-text="sslConfiguration.icon" v-if="sslStatus.security_wait" class="ml-2"/>
          <Icon v-else :icon="sslConfiguration.icon" class="mt-n1 ml-1" style="width: 15px; font-size:15px" iconSize="dense" color="shade-white"/>
        </div>
        <div class="icon-stepper rounded-circle gray" v-else>
          <p v-text="sslConfiguration.icon" style="color: #fff" class="ml-2"/>
        </div>
        <div class="ml-2" v-if="sslConfiguration">
          <p class="text-paragraph-2 gray--text text--scale500" v-text="sslConfiguration.title"/>
          <p class="text-caption gray--text text--scale500" v-text="sslConfiguration.subTitle"/>
        </div>
      </div>
      <div class="mt-6 ml-8" v-if="domainConfiguration.status">
        <div v-if="!sslStatus.status">
          <Button color="primary" label="Ativar SSL" :ga="gEvents.abrirModalSsl" @click="openModalSsl"/>
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
import { Row, Icon, Col, Button, Link } from '@locaweb/design-system-vue'
export default {
  name: 'AccordionStepper',
  components: {
    Icon,
    Row,
    Col,
    Button,
    Link
  },
  props: ['site', 'sslStatus', 'domainStatus'],
  data: () => ({
    stepeerOne: false,
    stepeerTwo: false
  }),
  methods: {
    openModalSsl () {
      this.$emit('openModalSsl')
    }
  },
  computed: {
    gEvents () {
      return this.$gEvents('listaDeSites')
    },
    completed () {
      return Number(this.step) > 1
    },
    sslConfiguration () {
      let objSsl = ''
      if (this.sslStatus.status && this.sslStatus.security_wait) {
        objSsl = {
          title: 'Estamos instalando seu Certificado SSL',
          subTitle: 'Essa ativação pode demorar 1 hora. Aguarde e faça testes de acesso ao seu site depois deste período.',
          status: true,
          security_wait: true,
          icon: '2',
          color: 'primary'
        }
      } else {
        objSsl = {
          title: 'Ative o Certificado SSL',
          subTitle: 'Ative o Certificado SSL para proteger informações importantes dos usuários que navegam no seu site.',
          status: false,
          security_wait: false,
          icon: '2',
          color: 'gray'
        }
      }
      return objSsl
    },
    domainConfiguration () {
      const title = {
        false: 'Domínio Aguardando Configuração',
        true: 'Domínio Configurado'
      }
      const subTitle = {
        false: 'Não detectamos seu domínio. Configure um domínio para usar seu site.'
      }
      const status = {
        true: true,
        false: false
      }
      const icon = {
        true: '$symbols-check-outline',
        false: '1'
      }
      const cor = {
        true: 'gray',
        false: 'success'
      }
      return {
        title: title[this.domainStatus],
        subTitle: subTitle[this.domainStatus],
        status: status[this.domainStatus],
        cor: cor[this.domainStatus],
        icon: icon[this.domainStatus]
      }
    }
  }
}
</script>

<style>
.icon-stepper{
  width: 23px;
  height: 23px;
}
</style>
